import { render, staticRenderFns } from "./loglist.vue?vue&type=template&id=0bd116d1&scoped=true&"
import script from "./loglist.vue?vue&type=script&lang=js&"
export * from "./loglist.vue?vue&type=script&lang=js&"
import style0 from "./loglist.vue?vue&type=style&index=0&id=0bd116d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd116d1",
  null
  
)

export default component.exports